import { render, staticRenderFns } from "./_Item.vue?vue&type=template&id=01a85194&scoped=true&"
import script from "./_Item.vue?vue&type=script&lang=js&"
export * from "./_Item.vue?vue&type=script&lang=js&"
import style0 from "./_Item.vue?vue&type=style&index=0&id=01a85194&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a85194",
  null
  
)

export default component.exports